module.exports = __webpack_public_path__ + "img/guofengmin.3b34c5e4.jpg";